// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_ServiceOrders_ListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /customer-portal/v1/service-orders/list
 *
 * `document` is accepted in ANY form (raw, unnormalized) — normalization is
 * server-side and happens AFTER fill()/validate(), mirroring
 * Customer_portal::clientes(). The base InputContract engine already rejects
 * a request with no `document` key at all (required, non-nullable, no
 * default); "empty after normalization" (e.g. a document that is nothing but
 * punctuation) is a second, later check the controller performs on the
 * normalized value — see the `@input-exception` note there.
 */
import { registerContract } from './validate'

export interface Portal_ServiceOrders_ListInput {
document: string
cursor?: string
limit?: number
}

registerContract('Portal_ServiceOrders_ListInput', {
  document: { type: 'string',  required: true },
  cursor:   { type: 'string',  required: false },
  limit:    { type: 'number',  required: false },
})
